import React from 'react';
import { PanelData, PanelStateProps } from '@nrdy-marketing-engine/form-wizard/@types';

const PanelContext = React.createContext<PanelData & PanelStateProps>({
  _modelApiKey: 'panel_content',
  headline: '',
  onInput: () => {},
  onNext: () => {},
  onBack: () => {},
  formData: {},
  validationErrors: {},
});

export default PanelContext;
